import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { openAssignModal } from "../devices.actions";
import { isAssignActionDisabled } from "../../../store/profiles/profiles.selectors";
import { Icon } from "../../icon/Icon";
import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";

export const useAssignAction = (
  device,
  isDeviceExists = false,
  validateImmediately = true
) => {
  const dispatch = useDispatch();

  return () =>
    dispatch(openAssignModal(device, isDeviceExists, validateImmediately));
};

/**
 * @param {*} device { identifiers: [identifier], type, name?, manufacturer? }
 * @param {string} messageId
 * @param {Boolean} isSavedDevice?
 * @param {Boolean} validateImmediately?
 */
export const useAssignDeviceMenuItem = (
  device,
  messageId,
  isSavedDevice = false,
  validateImmediately = true
) => {
  const assign = useAssignAction(device, isSavedDevice, validateImmediately);
  const isAssignDisabled = useSelector(isAssignActionDisabled);

  return {
    id: "assign",
    content: (
      <Fragment>
        <Icon icon="fa-regular fa-plus" />
        <span>
          <FormattedMessage id={messageId} />
        </span>
      </Fragment>
    ),
    disabled: isAssignDisabled,
    action: assign,
  };
};

export const AssignDeviceDropdownItem = ({
  device,
  messageId,
  isSavedDevice,
  validateImmediately,
  ...props
}) => {
  const { id, content, disabled, action } = useAssignDeviceMenuItem(
    device,
    messageId,
    isSavedDevice,
    validateImmediately
  );

  return (
    <LazyLoadDropdownItem
      id={id}
      disabled={disabled}
      action={action}
      {...props}
    >
      {content}
    </LazyLoadDropdownItem>
  );
};

export const AssignDeviceModalItem = ({
  device,
  messageId,
  isSavedDevice,
  validateImmediately,
}) => {
  const { id, content, disabled, action } = useAssignDeviceMenuItem(
    device,
    messageId,
    isSavedDevice,
    validateImmediately
  );

  return (
    <DeviceActionsModalItem id={id} disabled={disabled} action={action}>
      {content}
    </DeviceActionsModalItem>
  );
};
